<template>
  <div class="cookies-policy-popup container-fluid d-flex justify-content-center">
    <transition name="fade">
      <div v-if="show" class="cookies-policy-popup_inner">
        <font-awesome-icon
          :icon="['fas', 'times']"
          @click="close"
          class="cookies-policy-popup_close"
        />
        Продолжая использовать сайт, Вы соглашаетесь с обработкой персональных данных, собираемых посредством метрической программы «Яндекс.Метрика», в целях аналитики посещаемости сайта.
        <a href="/legal-info/cookies-policy" target="_blank">Политика использования файлов cookie</a>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CookiesPolicePopup',
  data () {
    return {
      visible: true,
    }
  },
  computed: {
    show () {
      return this.visible && !this.$cookies.get('cookies_policy_agree')
    },
  },
  methods: {
    close () {
      console.log(`Set cookies_policy_agree cookie to domain .${this.$config.appHost}`)
      this.visible = false
      this.$cookies.set('cookies_policy_agree', 1, {
        domain: '.' + this.$config.appHost,
      })
    },
  },

}
</script>

<style scoped lang="less">
      .cookies-policy-popup {
        position: fixed;
        z-index: 1000;
        bottom: 0;
        left: 0;
        transform: translateX(-50%);
        margin: 0px -50% 25px 50%;

        &_inner {
          padding:15px 43px 15px 15px;
          font-size: 12px;
          line-height: 1.3;
          border-radius: 15px;
          background-color: #fff;
          //box-shadow: rgba(6, 5, 50, 0.1) 0px 6px 20px;
          box-shadow: 0 3px 36px rgba(122, 122, 122, 0.5);
          position: relative;
          min-height: 25px;
        }

        &_close {
          position: absolute;
          right: 15px;
          top: 15px;
          cursor: pointer;
          color: #C2C2C2;
        }

        a {
          color: #da2f50;

          &:hover {
            text-decoration: none;
          }
        }

      }
</style>
